/**
 * This module manages the global variable containing the JWTs of the different products or the unscoped JWT
 */
import jwtDecode from 'jwt-decode';
import { storeJwtExpirationDate } from '../storage/storage';
import { getJwtKey, getJwtExpirationDateKey } from '../storage-keys/storage-keys';
const store = {};
function storeJwt(jwt, scope) {
    const decoded = jwtDecode(jwt);
    if (decoded) {
        const expireDate = new Date((decoded.exp || 0) * 1000);
        storeJwtExpirationDate(getJwtExpirationDateKey(scope), expireDate.getTime().toString());
        store[getJwtKey(scope)] = jwt;
    }
}
function getJwt(scope) {
    return store[getJwtKey(scope)];
}
export { storeJwt, getJwt, store };
